import { create } from "zustand";

export type BootPhase = "idle" | "parsing" | "ready" | "error";

interface BootState {
  phase: BootPhase;
  loadProgress: number;
  lastError: string | null;

  setPhase: (phase: BootPhase) => void;
  setLoadProgress: (progress: number) => void;
  setError: (message: string | null) => void;
  reset: () => void;
}

const initialState = {
  phase: "idle" as BootPhase,
  loadProgress: 0,
  lastError: null as string | null,
};

export const useBootStore = create<BootState>()((set) => ({
  ...initialState,

  setPhase: (phase) => set({ phase }),
  setLoadProgress: (loadProgress) => set({ loadProgress }),
  setError: (lastError) => set({ lastError, phase: lastError ? "error" : "idle" }),
  reset: () => set({ phase: "idle", loadProgress: 0, lastError: null }),
}));
